/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'am_header_menubtn': {
    width: 16,
    height: 16,
    viewBox: '0 0 129.6 454.5',
    data: '<path pid="0" d="M111.4 384.9H13.5v-16.2l79.1-28.8v-.3l-79.1-28.1v-15h97.9v13.9H15.7v.3l96.9 34.2v1.3L15.4 383v.3h96v1.6zM112.7 248.1c0 21.3-16.5 34.2-33.9 34.2-18.2 0-34.2-13.2-34.2-31.2 0-16.5 10.1-27.2 26.9-27.2v44.8c2.3.1 4.7.3 7.2.3 16.7 0 32.6-4.4 32.6-22.1 0-13.6-7.1-22-17.3-24.3l.3-1c11.9 2.4 18.4 12.6 18.4 26.5zm-42.1 20.6v-33c-18 0-25.1 4.4-25.1 15.5 0 10.5 9.7 16 25.1 17.5zM111.4 209.5H46.2v-12.9h11.2v-.1c-8.8-3.5-12.6-12.2-12.6-23.1 0-6 .4-10.2 2.1-13.6 2-4.4 5.4-7.8 12.6-7.8h51.9v12.9H57.8c-8.2 0-11.5 3.1-11.5 11.8 0 6.2 2.3 11.6 5.7 15 2.8 2.7 6.9 4.8 14.2 4.8h45.2v13zM46.2 77.9h65.2v12.9h-11.1v.1c8.5 3.5 12.3 11.8 12.3 22.7 0 6-.7 10.6-2.5 14-2.1 4.3-6.5 7.8-13.8 7.8H46.2v-13.1H99c8.2 0 12.1-3.4 12.1-12.1 0-6.2-2.1-11.3-5.5-14.8-2.8-2.7-7-4.8-14-4.8H46.2V77.9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/am_header_menubtn.js